import {
  FormCandidateModelFragment,
  StageCandidateModelFragment,
} from 'generated/graphql';
import {
  IFilteredTestActionCandidate,
  TestActionType,
} from './UserReset/UserResets.interface';

export const getStages = (
  stages?: StageCandidateModelFragment[] | null
) => {
  return (
    stages
      ?.slice()
      .reverse()
      .map(stage => {
        const { coderbyte, englishProficiency } = stage.actionCandidates;
        const testActionCandidates: IFilteredTestActionCandidate[] = [
          ...(stage.cognitiveTestActionCandidates ?? []).map(item => ({
            id: item.id,
            type: TestActionType.COGNITIVE,
            assessmentId: item.assessmentId,
            status: item.status,
            cognitiveKind: item.action.kind,
            timeModifierPercentage: item.timeModifierPercentage,
          })),
          ...(stage.personalityTestActionCandidate
            ? [
                {
                  id: stage.personalityTestActionCandidate.id,
                  type: TestActionType.PERSONALITY,
                  assessmentId: stage.personalityTestActionCandidate.assessmentId,
                  status: stage.personalityTestActionCandidate.status,
                },
              ]
            : []),
          ...(coderbyte
            ? [
                {
                  id: coderbyte.id,
                  type: TestActionType.CODERBYTE,
                  // Coderbyte sittings carry no assessment ID of our own; the
                  // Coderbyte test ID is what identifies them there.
                  assessmentId: coderbyte.action?.coderbyteTestId,
                  status: coderbyte.status,
                  timeModifierPercentage: coderbyte.timeModifierPercentage,
                  coderbyteAssessmentName: coderbyte.action?.name,
                  timeLimitInMinutes:
                    coderbyte.action?.details.timeLimitInMinutes,
                },
              ]
            : []),
          ...(englishProficiency
            ? [
                {
                  id: englishProficiency.id,
                  type: TestActionType.ENGLISH_PROFICIENCY,
                  assessmentId: englishProficiency.assessmentId,
                  status: englishProficiency.status,
                },
              ]
            : []),
        ];

        return {
          id: stage?.id,
          stageId: stage?.stage?.id,
          stageName: stage?.stage?.name,
          projectId: stage?.stage?.projectId,
          lastDateOfCandidateAction: stage?.lastDateOfCandidateAction,
          stageStatus: stage?.status,
          stageCandidateId: stage?.id,
          stageCandidateSubId: stage?.subId,
          doneFor: stage?.doneFor,
          doneBy: stage?.doneBy,
          rssAssessmentCandidates: stage?.rssAssessmentCandidates || [],
          formCandidates:
            (stage?.formCandidates as FormCandidateModelFragment[]) || [],
          deiForm: stage?.deiStageActionCandidate || null,
          filteredTestActionCandidates: testActionCandidates,
          projectCandidate: stage?.projectCandidate,
        };
      }) || []
  );
};
